"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MigrationTransformBase_1 = require("./MigrationTransformBase");

var object_1 = require("../../utils/object");

var AddTransform =
/** @class */
function (_super) {
  __extends(AddTransform, _super);

  function AddTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(AddTransform.prototype, "type", {
    get: function get() {
      return 'add';
    },
    enumerable: true,
    configurable: true
  });

  AddTransform.prototype.up = function (seed) {
    var _a = this.options,
        key = _a.key,
        parentJsPath = _a.parentJsPath,
        value = _a.value;
    var clone = object_1.deepMergeObjects({}, seed);
    var parentInstances = this.getParentInstances(clone, parentJsPath);

    for (var _i = 0, parentInstances_1 = parentInstances; _i < parentInstances_1.length; _i++) {
      var parentInstance = parentInstances_1[_i];
      parentInstance[key] = value;
    }

    return clone;
  };

  AddTransform.prototype.down = function (seed) {
    var _a = this.options,
        key = _a.key,
        parentJsPath = _a.parentJsPath,
        value = _a.value;
    var clone = object_1.deepMergeObjects({}, seed);
    var parentInstances = this.getParentInstances(clone, parentJsPath);

    for (var _i = 0, parentInstances_2 = parentInstances; _i < parentInstances_2.length; _i++) {
      var parentInstance = parentInstances_2[_i];
      delete parentInstance[key];
    }

    return clone;
  };

  return AddTransform;
}(MigrationTransformBase_1.MigrationTransformBase);

exports.AddTransform = AddTransform;